import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { Amplify } from 'aws-amplify';
import App from './App.tsx';
import './index.css';

// ─── Amplify configuration ────────────────────────────────────────────────────
// Phase 1: there is no live Cognito user pool yet, so these env vars are
// expected to be unset in local dev. Amplify.configure() with empty/undefined
// pool IDs won't throw itself, but guard anyway so a future misconfiguration
// (or an Amplify version that validates eagerly) can never blank the page —
// the site must still render its public marketing pages in logged-out mode.
const userPoolId = import.meta.env.VITE_COGNITO_USER_POOL_ID;
const userPoolClientId = import.meta.env.VITE_COGNITO_CLIENT_ID;

if (userPoolId && userPoolClientId) {
  try {
    Amplify.configure({
      Auth: {
        Cognito: {
          userPoolId,
          userPoolClientId,
        },
      },
    });
  } catch (err) {
    console.warn('Amplify.configure() failed — continuing in logged-out mode.', err);
  }
} else {
  console.warn(
    'VITE_COGNITO_USER_POOL_ID / VITE_COGNITO_CLIENT_ID are not set — auth is disabled, site will render in logged-out mode. This is expected in Phase 1 local dev.',
  );
}

const root = document.getElementById('root');
if (!root) throw new Error('Root element not found');

ReactDOM.createRoot(root).render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>,
);
